

import apiService from '@/api/request';
import {
    QUOTE_WS_URL
} from '../mutation-type';
export const getWsUrl = async ({ commit, state }) => {
    console.log('getWsUrl:');
    const res = await apiService.wssUrl();
    if (res.status === 1) {
      commit(QUOTE_WS_URL, res.data.quoteWssUrl);
    }
  };
